import { Workspace } from "@/lib/types";
import React, { useEffect, useState } from "react";
import { useWorkspaceStore } from "@/hooks/useWorkspace";
import { motion } from "motion/react";
import Plus from "@/assets/icons/Plus.svg";
import Checkmark from "@/assets/icons/Checkmark.svg";
import CreateWorkspaceModal from "@/components/Reports/CreateWorkspaceModal";
import { useNavigate } from "react-router-dom";

const WorkspacesDropdown = ({
  setIsOpenModal,
}: {
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { currentWorkspace, setCurrentWorkspace, workspaces } =
    useWorkspaceStore();
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="dropdown-shadow absolute top-[calc(100%+8px)] z-[1000] bg-gray-300 left-0 w-[280px] rounded-[16px]"
    >
      <ul className="p-1 flex flex-col gap-1 overflow-scroll max-h-[500px] no-scrollbar">
        {workspaces?.map((workspace) => {
          return (
            <li
              className={`${
                currentWorkspace?._id === workspace._id ? "bg-white/[0.08]" : ""
              } transition-all hover:bg-white/[0.16] text-[14px] leading-[20px] gap-2 shrink-0 font-medium h-[36px] px-2 rounded-[12px] flex items-center justify-between`}
              key={workspace._id}
              onClick={() => {
                if (workspace._id === currentWorkspace?._id) {
                  return;
                }
                setCurrentWorkspace(workspace);
                navigate(`/dashboard/${workspace._id}`);
              }}
            >
              <div className="flex items-center gap-2">
                <div className="relative">
                  <div
                    style={{ color: workspace?.color || "#FF0088" }}
                    className="text-[12px] leading-[16px] font-semibold absolute uppercase top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-white z-[10]"
                  >
                    {workspace?.name[0]}
                  </div>
                  <div
                    style={{ background: workspace?.color || "#FF0088" }}
                    className="opacity-[0.16] uppercase w-6 h-6 rounded-[8px]"
                  />
                </div>
                {workspace.name}
              </div>
              {currentWorkspace?._id === workspace._id && (
                <img src={Checkmark} />
              )}
            </li>
          );
        })}
      </ul>

      <div className="text-white h-[48px] p-1 text-[14px] leading-[20px] w-full rounded-none border-t-[4px] border-white/[0.08]">
        <button
          onClick={() => {
            setIsOpenModal(true);
          }}
          className="ring-0 px-3 gap-1.5 transition-all hover:bg-white/[0.16] rounded-[12px] w-full h-[36px] outline-0 flex items-center justify-center"
        >
          <img src={Plus} /> Create or join workspace
        </button>
      </div>
    </motion.div>
  );
};

export default WorkspacesDropdown;
